<template>
    <div class="row">
        <div class="col-md-12 p-10">
            <div class="card card-accent-primary" :class="{'card-accent-danger': isInvalid}">

                <div class="card-header">
                    <div class="row">
                        <div class="col-md-8 pointer" @click="toggleSettings"  :class="{'text-danger': isInvalid}">
                            <h5>
                                Mehrfachauswahl-Element (#{{ element.key }})
                            </h5>
                            <small v-if="isInvalid">
                                Bitte geben Sie mindestens 2 Werte ein.
                            </small>
                        </div>
                        <div class="col-md-4 text-right">
                            <button class="btn btn-sm btn-primary"
                                    :class="{ disabled: $parent.hasLowestSort(element) }"
                                    :disabled="$parent.hasLowestSort(element)"
                                    @click="$parent.moveElementUp(element)">
                                <i class="fas fa-arrow-up"></i>
                            </button>
                            <button class="btn btn-sm btn-primary mr-4"
                                    :class="{ disabled: $parent.hasHighestSort(element) }"
                                    :disabled="$parent.hasHighestSort(element)"
                                    @click="$parent.moveElementDown(element)">
                                <i class="fas fa-arrow-down"></i>
                            </button>
                            <button @click="$parent.removeElementByKey(element.key)" class="btn btn-danger btn-sm">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body" v-if="this.showSettings">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="textInput">Beschreibungstext</label>
                            <input type="text" id="textInput" class="form-control" placeholder="Dieser Text wird vor dem Feld angezeigt" v-model="element.text">
                        </div>

                        <div class="col-md-12 mt-2">
                            <label for="addValueElement">Wert hinzufügen</label>
                            <input type="text" id="addValueElement" class="form-control" @keyup.enter="addValue" v-model="currentValue">
                            <button class="btn btn-outline-success btn-sm mt-2" @click="addValue">
                                <i class="fas fa-plus"></i> Hinzufügen
                            </button>
                            <br>

                            <label for="existingValues" class="mt-4" v-if="element.values.length">Werte</label>
                            <div class="mt-2" id="existingValues">
                                <p v-for="value in element.values" class="mt-1">
                                    <button class="btn btn-outline-danger btn-sm text-right" @click="removeValue(value)">
                                        <i class="fas fa-times"></i>
                                    </button>
                                    &nbsp; {{ value }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <hr>
                            <strong>Validierung</strong>
                        </div>
                        <div class="col-md-4">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" :id="'validation-required-' + element.key" v-model="element.validation.required">
                                <label class="custom-control-label" :for="'validation-required-' + element.key">
                                    Pflichtfeld?
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BuilderMultiSelectElement",
        props: ['element'],
        data() {
            return {
                showSettings: true,
                currentValue: ''
            }
        },
        computed: {
            isInvalid() {
                let validation = this.element.validation;

                if(this.element.values.length < 2)
                    return true;

                return false;
            }
        },
        methods: {
            toggleSettings() {
                this.showSettings = !this.showSettings;
            },
            addValue() {
                if(!this.currentValue.length)
                    return false;

                this.element.values.push(this.currentValue);
                this.currentValue = '';
            },
            removeValue(string) {
                var index = this.element.values.indexOf(string);
                if (index !== -1) {
                    this.element.values.splice(index, 1);
                }
            }
        }
    }
</script>

<style scoped>

    label {
        font-style: italic;
    }
</style>
